import { lazyLogCLPAriaDataPoint, logUsage } from 'owa-analytics';
import {
    CLPLabelAriaProperties,
    CLPLabelChangeAriaProperties,
} from '../store/schema/CLPLabelAriaProperties';
import CLPViewState from '../store/schema/CLPViewState';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import CLPLabelResponse from '../store/schema/CLPLabelResponse';
import { now, getISOString } from 'owa-datetime';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function logDowngradeJustification(
    clpViewState: CLPViewState,
    downgradeJustification: string
) {
    const commonCLPAriaProperties = getCommonCLPAriaProperties(
        clpViewState.selectedCLPLabel,
        'Change'
    );
    const { originalCLPLabel, selectedCLPLabel } = clpViewState;
    const clpLabelChangeAriaProperties: CLPLabelChangeAriaProperties = {
        ...commonCLPAriaProperties,
        IsLabelChanged: true,
        LabelIdBefore: originalCLPLabel.id,
        IsProtectionChanged:
            originalCLPLabel.isEncryptingLabel != selectedCLPLabel.isEncryptingLabel,
        ProtectedBefore: originalCLPLabel.isEncryptingLabel,
        UserJustification: downgradeJustification,
    };

    lazyLogCLPAriaDataPoint.importAndExecute(clpLabelChangeAriaProperties);
}

export function logReadCLPLabel(clpLabelToLog: CLPLabel) {
    const clpAriaProperties = getCommonCLPAriaProperties(clpLabelToLog, 'Discover');
    lazyLogCLPAriaDataPoint.importAndExecute(clpAriaProperties);
}

export function logCLPLabelLoadDatapoint(labelResp: CLPLabelResponse) {
    if (labelResp) {
        logUsage('LoadCLPLabelOnBoot', {
            isLabelListEmpty: !labelResp.value || labelResp.value.length == 0,
        });
    }
}

export function logCLPComposeUsage(label: CLPLabel) {
    if (label) {
        logUsage('LoadCLPLabelComposeUsage', {
            isDefaultLabel: label.isDefault,
            isEncryptingLabel: label.isEncryptingLabel,
        });
    }
}

export function logCLPLabelChange(originalLabel: CLPLabel, newLabel?: CLPLabel) {
    if (newLabel && originalLabel) {
        logUsage('LoadCLPLabelChange', {
            isDowngrade: originalLabel.settingOrder > newLabel.settingOrder,
            isOriginalLabelDefault: originalLabel.isDefault,
        });
    } else if (originalLabel) {
        logUsage('LoadCLPLabelUnselect', {
            isOriginalLabelDefault: originalLabel.isDefault,
            isOriginalLabelEncrypting: originalLabel.isEncryptingLabel,
        });
    }
}

function getCommonCLPAriaProperties(
    clpLabelToLog: CLPLabel,
    operation: string
): CLPLabelAriaProperties {
    const {
        ExternalDirectoryTenantGuid,
        UserEmailAddress,
    } = getUserConfiguration().SessionSettings;
    return {
        CreationTime: getISOString(now()),
        Version: '1.1',
        Operation: operation,
        OrganizationId: ExternalDirectoryTenantGuid,
        UserId: UserEmailAddress,
        ApplicationId: '00000002-0000-0ff1-ce00-000000000000',
        ApplicationName: 'Outlook Web',
        DataState: 'Use',
        LabelId: clpLabelToLog ? clpLabelToLog.id : null,
        Protected: clpLabelToLog ? clpLabelToLog.isEncryptingLabel : null,
    };
}
